'use client';

import {useTranslations, useLocale} from 'next-intl';
import Card, {CardBody} from '../ui/Card';

const programs = [
  {key: 'social', icon: '🤝', border: 'border-t-4 border-t-primary'},
  {key: 'assistance', icon: '🆘', border: 'border-t-4 border-t-accent'},
  {key: 'income', icon: '💼', border: 'border-t-4 border-t-success'},
  {key: 'microcredit', icon: '🏦', border: 'border-t-4 border-t-warning'},
] as const;

export default function ProgramsSection() {
  const t = useTranslations('home');
  const locale = useLocale();

  return (
    <section className="py-24 bg-surface relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-primary/20 rounded-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-secondary mb-4">
            {t('programs_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {programs.map(({key, icon, border}) => (
            <Card key={key} hover className={`${border} !rounded-t-none`}>
              <div className="text-center py-2">
                <div className="text-4xl mb-4">{icon}</div>
                <h3 className="text-lg font-bold text-secondary mb-3">
                  {t(`programs_${key}`)}
                </h3>
              </div>
              <CardBody>
                <p className="text-muted text-sm leading-relaxed text-center">
                  {t(`programs_${key}_desc`)}
                </p>
              </CardBody>
            </Card>
          ))}
        </div>

        <div className="text-center mt-10">
          <a href={`/${locale}/programmes`} className="inline-flex items-center gap-2 text-primary font-semibold hover:text-primary-light transition-colors">
            {t('programs_title')} &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
